import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { track } from './analytics/track';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

track('session_started', { platform: 'pwa' });

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
